/**
 * The type of an individual challenge criterion.
 * From CriterionTypeV1:
 * https://github.com/post-quantum/check/blob/master/check-api/src/main/java/io/idaas/check/api/enums/CriterionTypeV1.java
 */
export enum ChallengeCriterionType {
  FaceMatch = 'face',
  VoiceMatch = 'voice',
  SpokenMatch = 'phrase',
}
